import React, { createContext, useCallback, useEffect, useState } from 'react';
import { userBookingAxios } from 'APIs';
import { useParams } from 'react-router';

interface UserBookingDetails {
  isLoading: boolean;
  status: number;
  error: boolean;
  data: any[];
}

interface PartnerContextType {
  partnerBookings: UserBookingDetails;
  refetchBookings: () => void;
}

export const PartnerContextDetail = createContext<PartnerContextType | undefined>(
  undefined
);

export const PartnereDetailsProvier: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { partnerId } = useParams();

  const [partnerBookings, setPartnerBookings] =
    useState<UserBookingDetails>({
      isLoading: true,
      status: 0,
      error: false,
      data: [],
    });

  const fetchBookingData = useCallback( async () => {
    try {
      setPartnerBookings((prev) => ({ ...prev, isLoading: true }));

      const response = await userBookingAxios.get('/bookings', {
        headers: {
          userId: partnerId,
          offset: '',
          limit: '',
          search: '',
          filter: '',
        },
      });

      const {
        data: { error, data },
        status,
      } = response;

      setPartnerBookings({
        isLoading: false,
        status,
        error,
        data,
      });
    } catch (err) {
      console.error('Booking error', err);
      setPartnerBookings((prev) => ({
        ...prev,
        isLoading: false,
        error: true,
      }));
    }
  },[partnerId]);

  useEffect(() => {
    if (partnerId) {
      fetchBookingData();
    }
  }, [partnerId,fetchBookingData]);

  return (
    <PartnerContextDetail.Provider
      value={{ partnerBookings, refetchBookings: fetchBookingData }}
    >
      {children}
    </PartnerContextDetail.Provider>
  );
};
